import React from 'react';
import { theme } from 'tailwind.config'

interface CircularProgressProps {
  progress: number; // 0 a 100
  size?: number;    // Tamanho em pixels
  strokeWidth?: number;
  circleColor?: string;
  progressColor?: string;
  hideText?: boolean;
}

const ProgressCircle = ({
  progress = 0,
  size = 32,
  strokeWidth = 2,
  circleColor = '#e5e7eb',
  progressColor = '#FFF',
  hideText = true
}: CircularProgressProps) => {
  // Configurações do círculo
  const center = size / 2;
  const radius = center - strokeWidth;
  const circumference = 2 * Math.PI * radius;
  
  // Cálculo do offset: quanto menor o offset, mais a barra "enche"
  // Invertemos para que 0 seja vazio e 100 seja cheio
  const offset = circumference - (progress / 100) * circumference;

  return (
    <div className="flex items-center justify-center" style={{ width: size, height: size }}>
      <svg
        width={size}
        height={size}
        className="transform -rotate-90" // Rotaciona para o progresso começar no topo
      >
        {/* Círculo de Fundo (Trilho) */}
        <circle
          cx={center}
          cy={center}
          r={radius}
          stroke={circleColor}
          strokeWidth={strokeWidth}
          fill="#FFFFFF05"
        />
        
        {/* Círculo de Progresso */}
        <circle
          cx={center}
          cy={center}
          r={radius}
          stroke={progressColor}
          strokeWidth={strokeWidth}
          fill="transparent"
          strokeDasharray={circumference}
          style={{
            strokeDashoffset: offset,
            transition: 'stroke-dashoffset 0.5s ease-in-out',
            strokeLinecap: 'round' // Deixa as pontas arredondadas
          }}
        />
      </svg>
      
      {!hideText &&<div className="absolute inset-0 flex items-center justify-center">
        <span className="text-xl font-bold" style={{ color: '#374151' }}>
          {Math.round(progress)}%
        </span>
      </div>}
    </div>
  );
};

export default ProgressCircle;